import {CanvasState} from '@catdetails/components/project-lopa-positions/canvas-state';
import {
  EntityBackedCanvasDrawable
} from '@catdetails/components/project-lopa-positions/drawable/canvas-drawable';

export class Polygon<T> implements EntityBackedCanvasDrawable<T> {
  private readonly hitMapColor: string;
  selected: boolean;
  public allPoints: number[][] = [];

  constructor(public entity: T, public updateFromEntity: (poly: Polygon<T>) => void, public updateEntity: (poly: Polygon<T>) => void,
              public getStrokeColor: (poly: Polygon<T>) => string = (poly) => '#2364c8', public hasChanged: (poly: Polygon<T>) => boolean) {
    this.hitMapColor = CanvasState.getNextHitMapColor(this);
    this.updateFromEntity(this);
  }

  draw(context: CanvasRenderingContext2D, hitMapContext?: CanvasRenderingContext2D) {
    if (this.allPoints.length === 0) {
      return;
    }
    this.selected = false;
    context.strokeStyle = this.getStrokeColor(this);
    context.lineWidth = 2;
    this.drawPath(context);
    context.stroke();
    if (hitMapContext) {
      hitMapContext.fillStyle = this.hitMapColor;
      this.drawPath(hitMapContext);
      hitMapContext.fill();
    }
  }

  select(context: CanvasRenderingContext2D, selectionColor: string, selectionWidth: number): void {
    if (this.allPoints.length === 0) {
      return;
    }
    this.selected = true;
    context.strokeStyle = selectionColor;
    context.lineWidth = selectionWidth;
    this.drawPath(context);
    context.stroke();
  }

  private drawPath(context: CanvasRenderingContext2D) {
    context.beginPath();
    context.moveTo(this.allPoints[0][0], this.allPoints[0][1]);
    for (let i = 1; i < this.allPoints.length; i++) {
      context.lineTo(this.allPoints[i][0], this.allPoints[i][1]);
    }
    context.closePath();
  }

  move(dx: number, dy: number) {
    this.allPoints.forEach((point: number[], index: number, array: number[][]) => {
      array[index][0] += dx;
      array[index][1] += dy;
    });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/components/project-lopa-positions/drawable/polygon.ts